import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "axios"

const { REACT_APP_API_ROUTE: API_ROUTE } = process.env

const initialState = {
  status: "idle",
  data: null,
  error: "",
}

export const confSlice = createSlice({
  name: "conf",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(findAll.pending, (state, action) => {
      state.status = "loading"
    })
    builder.addCase(findAll.fulfilled, (state, action) => {
      state.status = "succeeded"
      state.data = action.payload
    })
    builder.addCase(findAll.rejected, (state, action) => {
      state.status = "failed"
      state.error = action.payload
    })
  },
})

export const findAll = createAsyncThunk("/conf", async (arg, thunkAPI) => {
  try {
    const endpoint = "/conf"
    const { data } = await axios.get(API_ROUTE + endpoint)
    return thunkAPI.fulfillWithValue(data)
  } catch (ex) {
    console.log(ex)
    return thunkAPI.rejectWithValue(ex.message)
  }
})
export const getConf = (state) => state.conf
export default confSlice.reducer
